$(document).ready(function () {
  function showDeliverEveryBox () {
    $('.custom-recharge-widget__deliver-every-box').addClass('show')
    SELLING_PLAN_WIDGET_RECHARGE_ID = $('.custom-recharge-widget__deliver-every-input:checked').val()
    $('.custom-recharge-widget__deliver-every-input').on('click', addSellingPlanId)

  }
  function hiddenDeliverEveryBox () {
    $('.custom-recharge-widget__deliver-every-box').removeClass('show')
    $('.custom-recharge-widget__deliver-every-label').off('click')
    SELLING_PLAN_WIDGET_RECHARGE_ID = ''
  }
  function addSellingPlanId () {
    SELLING_PLAN_WIDGET_RECHARGE_ID = Number($(this).val())
  }
  $('.custom-recharge-widget__purchase-option-label[data-name="save"]').on('click',showDeliverEveryBox)
  $('.custom-recharge-widget__purchase-option-label[data-name="one"]').on('click',hiddenDeliverEveryBox)

    $('.custom-recharge-widget__purchase-option-label').on('click', function (){
      console.log('this', this);
    let currentPrice = $(this).find('.custom-recharge-widget__purchase-option-text-price').text();
    let originalPrice = $(this).find('.regular_price').text();
    let discountedPrice = $(this).find('#discountedPriceNow').text();

    // $(this).closest('.product__info-container').find('.price__container').html(currentPrice);
    // $(this).closest('.product__info-container').find('.recharge-inner-most-price').html(currentPrice);
    // console.log(currentPrice, 'currentPrice')

    setTimeout(() => {
      const regularPriceContainer = $(this).closest('.product__info-container').find('.price__container #product_custom_price_regular');
      const salePriceParent = $(this).closest('.product__info-container').find('.price__container .price__sale');
      const salePriceContainer = $(this).closest('.product__info-container').find('#product_custom_price_sale');

      const isSubscribe = $(this).data('name') === 'save';
      const oneTimePrice = $(this).find('.regular_product_price').text();
      const priceForRegular = isSubscribe ? discountedPrice : oneTimePrice;

      regularPriceContainer.html(priceForRegular);
      salePriceContainer.html(originalPrice);
      salePriceParent.css('display', 'block');
      salePriceContainer.css('display', 'block');
      
      regularPriceContainer.attr('data-widget-controlled', 'true');
      salePriceContainer.attr('data-widget-controlled', 'true');
    }, 500);
    })

  function enableSelectDropdown() {
    $('.custom-recharge-widget__purchase-option-label[data-name="save"]').closest('.custom-recharge-widget').find('#selling_plans').prop('disabled', false);
    console.log('enabled');
  }

  function disableSelectDropdown() {
    $('.custom-recharge-widget__purchase-option-label[data-name="one"]').closest('.custom-recharge-widget').find('#selling_plans').prop('disabled', true);
    console.log('disabled');
  }

  function onLoadSaveSelected() {
    setTimeout(() => {
      $('.custom-recharge-widget:visible .custom-recharge-widget__purchase-option-label[data-name="save"]').each(function(){
        var $input = $(this).find('.custom-recharge-widget__purchase-option-input');
        if (!$input.prop('checked')) {
          $input.prop('checked', true);
        }
        $(this).trigger('click');
      });
    }, 200)
  }

  function observeRechargeWidget() {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              const rechargeWidget = node.querySelector ? 
                node.querySelector('.rc-radio.rc-option__subsave input') || 
                node.querySelector('#rc_radio_options .rc-option__subsave input') ||
                (node.classList && node.classList.contains('rc-option__subsave') ? node.querySelector('input') : null) :
                null;
              
              if (rechargeWidget) {
                console.log('Found Recharge widget, selecting subscription option');
                setTimeout(() => {
                  rechargeWidget.checked = true;
                  rechargeWidget.dispatchEvent(new Event('change', { bubbles: true }));
                  rechargeWidget.dispatchEvent(new Event('click', { bubbles: true }));
                }, 100);
              }
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(() => {
      const existingRechargeWidget = document.querySelector('.rc-radio.rc-option__subsave input') || 
                                   document.querySelector('#rc_radio_options .rc-option__subsave input');
      if (existingRechargeWidget) {
        console.log('Found existing Recharge widget, selecting subscription option');
        existingRechargeWidget.checked = true;
        existingRechargeWidget.dispatchEvent(new Event('change', { bubbles: true }));
        existingRechargeWidget.dispatchEvent(new Event('click', { bubbles: true }));
      }
    }, 500);

    setTimeout(() => {
      const delayedRechargeWidget = document.querySelector('.rc-radio.rc-option__subsave input') || 
                                   document.querySelector('#rc_radio_options .rc-option__subsave input');
      if (delayedRechargeWidget && !delayedRechargeWidget.checked) {
        console.log('Found delayed Recharge widget, selecting subscription option');
        delayedRechargeWidget.checked = true;
        delayedRechargeWidget.dispatchEvent(new Event('change', { bubbles: true }));
        delayedRechargeWidget.dispatchEvent(new Event('click', { bubbles: true }));
      }
    }, 1000);
  }
  
  onLoadSaveSelected();
  observeRechargeWidget();

  $('.custom-recharge-widget__purchase-option-label[data-name="save"]').on('click', function() {
    enableSelectDropdown();
    const rechargeSubscribe = document.querySelector('.rc-radio.rc-option__subsave input');
    if (rechargeSubscribe) {
      rechargeSubscribe.checked = true;
      rechargeSubscribe.dispatchEvent(new Event('change', { bubbles: true }));
      rechargeSubscribe.dispatchEvent(new Event('click', { bubbles: true }));
    }
  });

  $('.custom-recharge-widget__purchase-option-label[data-name="one"]').on('click', function() {
    disableSelectDropdown();
    const rechargeOneTime = document.querySelector('.rc-radio.rc-option__onetime input');
    if (rechargeOneTime) {
      rechargeOneTime.checked = true;
      rechargeOneTime.dispatchEvent(new Event('change', { bubbles: true }));
      rechargeOneTime.dispatchEvent(new Event('click', { bubbles: true }));
    }
  });
 
  var quantityInput = $('.quantity-selector input[type="number"]');

  $('.quantity-minus').on('click', function() {
    var currentValue = parseInt(quantityInput.val());
    if (!isNaN(currentValue) && currentValue > 1) {
      quantityInput.val(currentValue - 1);
    }
  });

  $('.quantity-plus').on('click', function() {
    var currentValue = parseInt(quantityInput.val());
    if (!isNaN(currentValue)) {
      quantityInput.val(currentValue + 1);
    }
  });

})
